const BASE_URL = process.env.REACT_APP_SERVER_URL;

const BASE_USER_URL = '/envision/api/user';
const BASE_PROFILE_URL = '/envision/api/profile';
const BASE_EMPLOYEE_URL = '/envision/api/employee';
const BASE_LEAVE_URL = '/envision/api/leaves';
const BASE_ATTENDANCE_URL = '/envision/api/attendance';
const BASE_AUTOCOMPLETE_URL = '/envision/api/autocomplete';
const BASE_LOAN_URL = '/envision/api/loan';
const BASE_OVERTIME_URL = '/envision/api/overtime';
const BASE_COMP_OFF_URL = '/envision/api/comp-off';
const BASE_APPROVAL_URL = '/envision/api/approval';
const BASE_EVENT_URL = '/envision/api/event';
const BASE_EXPENSE_URL = '/envision/api/expense';
const BASE_COMMON_URL = '/envision/api/common';
const BASE_DOCUMENT_URL = '/envision/api/document';
const BASE_HOLIDAY_URL = '/envision/api/holiday';
const BASE_TRAVEL_URL = '/envision/api/travel';
const BASE_TRAVEL_REQUEST_URL = '/envision/api/travel-request';
const BASE_ROLE_URL = '/envision/api/role';
const BASE_ADMIN_URL = '/envision/api/admin';
const BASE_PRIVILEGES_URL = '/envision/api/privileges';
const BASE_TICKET_URL = '/envision/api/ticket';
const BASE_BONUS_URL = '/envision/api/bonus';
const BASE_FAQ_URL = '/envision/api/faq';
const BASE_REASSIGN_APPROVAL_URL = '/envision/api/reassign-approval';
const BASE_MEDIA_URL = '/envision/api/media';
const BASE_DASHBOARD_URL = '/envision/api/dashboard';
const BASE_HR_EXPENSE_URL = '/envision/api/hr/expense';
const BASE_PERFORMANCE_URL = '/envision/api/performance';
const BASE_CALIBRATION_URL = '/envision/api/calibration';
const BASE_HR_URL = '/envision/api/hr';
const CODE_LIST_URL = '/envision/api/codelist';

export {
  BASE_URL,
  BASE_USER_URL,
  BASE_PROFILE_URL,
  BASE_ATTENDANCE_URL,
  BASE_EMPLOYEE_URL,
  BASE_LEAVE_URL,
  BASE_AUTOCOMPLETE_URL,
  BASE_LOAN_URL,
  BASE_OVERTIME_URL,
  BASE_COMP_OFF_URL,
  BASE_APPROVAL_URL,
  BASE_EVENT_URL,
  BASE_EXPENSE_URL,
  BASE_COMMON_URL,
  BASE_DOCUMENT_URL,
  BASE_HOLIDAY_URL,
  BASE_TRAVEL_URL,
  BASE_TRAVEL_REQUEST_URL,
  BASE_ROLE_URL,
  BASE_ADMIN_URL,
  BASE_PRIVILEGES_URL,
  BASE_TICKET_URL,
  BASE_BONUS_URL,
  BASE_FAQ_URL,
  BASE_REASSIGN_APPROVAL_URL,
  BASE_MEDIA_URL,
  BASE_DASHBOARD_URL,
  BASE_HR_EXPENSE_URL,
  BASE_PERFORMANCE_URL,
  BASE_CALIBRATION_URL,
  BASE_HR_URL,
  CODE_LIST_URL,
};
